import { render, staticRenderFns } from "./voice.vue?vue&type=template&id=7109ebaa&"
import script from "./voice.js?vue&type=script&lang=js&"
export * from "./voice.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports